import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Values Section - staggered fade in with rotation from center
 */
export const animateValuesSection = (ref) => {
  if (ref.current) {
    // Set initial state immediately to prevent flash
    const items = ref.current.querySelectorAll('[class*="valueCard"]');
    if (items.length > 0) {
      gsap.set(items, { opacity: 0, scale: 0.8, rotation: -10 });
    }
    
    const timer = setTimeout(() => {
      if (items.length > 0) {
        gsap.to(items, {
          opacity: 1,
          scale: 1,
          rotation: 0,
          duration: 0.9,
          stagger: 0.2,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
        ScrollTrigger.refresh();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

